import { MessageKey } from '../messaging/MessageKey';
import { Step } from '../views/Step';
import { getQueryParam } from '../routing/getQueryParam';
const LiveChatMessageKeys = {
  [Step.LandingPage]: MessageKey.DIST008LiveChatLandingPage,
  [Step.EmailOnlyLandingPage]: MessageKey.DIST008LiveChatLandingPage,
  [Step.Industry]: MessageKey.DIST008LiveChatIndustry,
  [Step.JobRole]: MessageKey.DIST008LiveChatJobRole,
  [Step.CompanyName]: MessageKey.DIST008LiveChatCompanyName,
  [Step.CompanySize]: MessageKey.DIST008LiveChatCompanySize,
  [Step.CompanyDomain]: MessageKey.DIST008LiveChatCompanyWebsite,
  [Step.CrmExperienceLevel]: MessageKey.DIST008LiveChatCrmExperience,
  [Step.HubInterest]: MessageKey.DIST008LiveChatCrmPlatform
};
const MeetingsMessageKeys = {
  [Step.LandingPage]: MessageKey.DIST008MeetingsLandingPage,
  [Step.EmailOnlyLandingPage]: MessageKey.DIST008MeetingsLandingPage,
  [Step.Industry]: MessageKey.DIST008MeetingsIndustry,
  [Step.JobRole]: MessageKey.DIST008MeetingsJobRole,
  [Step.CompanyName]: MessageKey.DIST008MeetingsCompanyName,
  [Step.CompanySize]: MessageKey.DIST008MeetingsCompanySize,
  [Step.CompanyDomain]: MessageKey.DIST008MeetingsCompanyWebsite,
  [Step.CrmExperienceLevel]: MessageKey.DIST008MeetingsCrmExperience,
  [Step.HubInterest]: MessageKey.DIST008MeetingsCrmPlatform
};
const FormsMessageKeys = {
  [Step.LandingPage]: MessageKey.DIST008FormsLandingPage,
  [Step.EmailOnlyLandingPage]: MessageKey.DIST008FormsLandingPage,
  [Step.Industry]: MessageKey.DIST008FormsIndustry,
  [Step.JobRole]: MessageKey.DIST008FormsJobRole,
  [Step.CompanyName]: MessageKey.DIST008FormsCompanyName,
  [Step.CompanySize]: MessageKey.DIST008FormsCompanySize,
  [Step.CompanyDomain]: MessageKey.DIST008FormsCompanyWebsite,
  [Step.CrmExperienceLevel]: MessageKey.DIST008FormsCrmExperience,
  [Step.HubInterest]: MessageKey.DIST008FormsCrmPlatform
};
const DIST008StepMessageKeys = {
  'hubspot-livechat-virality': LiveChatMessageKeys,
  'hubspot-meetings-virality': MeetingsMessageKeys,
  'hubspot-forms-virality': FormsMessageKeys,
  'hubspot-lead-flows-virality': FormsMessageKeys
};

function isVirality() {
  return getQueryParam('utm_medium') === 'virality' || getQueryParam('hubs_medium') === 'virality';
}

function getUtmCampaign() {
  return getQueryParam('utm_campaign') || getQueryParam('hubs_campaign');
}

export function isExposedToDist008() {
  return isVirality() && Object.keys(DIST008StepMessageKeys).includes(getUtmCampaign());
}
export function getDist008Message(currentStep) {
  const flow = getUtmCampaign();
  const keys = DIST008StepMessageKeys[flow];
  if (!keys) return null;
  return keys[currentStep] || null;
}